import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import api from '../utils/api';
import './Account.css';

export default function Account() {
const { user } = useAuth();
const [form, setForm] = useState({ name: '', email: '', phone: '', phone_secondary: '' });
const [pwForm, setPwForm] = useState({ currentPassword: '', newPassword: '', confirmPassword: '' });
const [saving, setSaving] = useState(false);
const [savingPw, setSavingPw] = useState(false);
const [message, setMessage] = useState('');
const [error, setError] = useState('');
const [pwMessage, setPwMessage] = useState('');
const [pwError, setPwError] = useState('');

useEffect(() => {
api.get('/account').then(res => {
const u = res.data.user;
setForm({
name: u.name || '',
email: u.email || '',
phone: u.phone || '',
phone_secondary: u.phone_secondary || '',
});
});
}, []);

const handleSave = async (e) => {
e.preventDefault();
setSaving(true);
setMessage('');
setError('');
try {
await api.patch('/account', form);
setMessage('Profile updated successfully!');
} catch (err) {
setError(err.response?.data?.error || 'Failed to update profile');
} finally {
setSaving(false);
}
};

const handlePasswordChange = async (e) => {
e.preventDefault();
setPwMessage('');
setPwError('');
if (pwForm.newPassword !== pwForm.confirmPassword) {
setPwError('New passwords do not match');
return;
}
setSavingPw(true);
try {
await api.post('/auth/change-password', {
currentPassword: pwForm.currentPassword,
newPassword: pwForm.newPassword,
});
setPwMessage('Password changed successfully!');
setPwForm({ currentPassword: '', newPassword: '', confirmPassword: '' });
} catch (err) {
setPwError(err.response?.data?.error || 'Failed to change password');
} finally {
setSavingPw(false);
}
};

const initials = form.name
? form.name.split(' ').map(n => n[0]).join('').toUpperCase().substring(0, 2)
: '?';

return (
<div className="account-page container">
<div className="account-page__header">
<div className="account-avatar">{initials}</div>
<div>
<h1>{form.name}</h1>
<p>{form.phone}</p>
</div>
</div>

<div className="account-page__grid">
{/* Profile Form */}
<div className="account-card">
<h2>Profile Information</h2>
<form onSubmit={handleSave} className="account-form">
<div className="form-group">
<label>Full Name</label>
<input
type="text"
value={form.name}
onChange={e => setForm({...form, name: e.target.value})}
placeholder="Your name"
/>
</div>
<div className="form-group">
<label>Email Address</label>
<input
type="email"
value={form.email}
onChange={e => setForm({...form, email: e.target.value})}
placeholder="you@example.com"
/>
</div>
<div className="form-group">
<label>Phone Number (Login)</label>
<input
type="tel"
value={form.phone}
onChange={e => setForm({...form, phone: e.target.value})}
placeholder="602-716-1121"
/>
</div>
<div className="form-group">
<label>Secondary Phone <span className="optional">(optional)</span></label>
<input
type="tel"
value={form.phone_secondary}
onChange={e => setForm({...form, phone_secondary: e.target.value})}
placeholder="Optional secondary number"
/>
</div>
{message && <div className="account-success">{message}</div>}
{error && <div className="account-error">{error}</div>}
<button type="submit" className="btn btn-primary" disabled={saving}>
{saving ? <span className="spinner" /> : 'Save Changes'}
</button>
</form>
</div>

{/* Password Form */}
<div className="account-card">
<h2>Change Password</h2>
<form onSubmit={handlePasswordChange} className="account-form">
<div className="form-group">
<label>Current Password</label>
<input
type="password"
value={pwForm.currentPassword}
onChange={e => setPwForm({...pwForm, currentPassword: e.target.value})}
placeholder="••••••••"
required
/>
</div>
<div className="form-group">
<label>New Password</label>
<input
type="password"
value={pwForm.newPassword}
onChange={e => setPwForm({...pwForm, newPassword: e.target.value})}
placeholder="Min 8 characters"
required
minLength={8}
/>
</div>
<div className="form-group">
<label>Confirm New Password</label>
<input
type="password"
value={pwForm.confirmPassword}
onChange={e => setPwForm({...pwForm, confirmPassword: e.target.value})}
placeholder="••••••••"
required
/>
</div>
{pwMessage && <div className="account-success">{pwMessage}</div>}
{pwError && <div className="account-error">{pwError}</div>}
<button type="submit" className="btn btn-primary" disabled={savingPw}>
{savingPw ? <span className="spinner" /> : 'Change Password'}
</button>
</form>
</div>
</div>
</div>
);
}
